import './navbar.scss';
import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Navigation from '@components/navbar/Navigation';
import NavigationSearch from '@components/navbar/NavigationSearch';

const SKIP_LINKS = [
  {
    title: 'Go into news section',
    id: 'news',
  }, {
    title: ' Go into GIDS Mandatory section',
    id: 'gids-mandatory',
  }, {
    title: ' Go into Design Documents section',
    id: 'design-documents',
  },
];

export default function Navbar() {
  const user = useSelector((state) => state.user.loggedUser);
  const [searchActive, setSearchActive] = useState(false);
  const searchInputRef = useRef(null);

  const toggleSearchActive = useCallback(() => {
    setSearchActive((old) => !old);
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 400);
  }, [searchInputRef]);

  const moveIntoSection = (id) => {
    const section = document.getElementById(id);

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    section.focus();
  };

  return (
    <header aria-label='Global Innovation & Design Standards'>
      <div className='skip-links'>
        {SKIP_LINKS.map((elem) => (
          <button className='skip-link' type='button' key={elem.id} onClick={() => moveIntoSection(elem.id)}>
            {elem.title}
          </button>
        ))}
      </div>

      <nav className={`navigation ${user ? 'logged' : ''}`}>
        <div className='navigation__base'>
          <div className='navigation__body'>
            <Link to='/' className='navigation__logo'>
              <span className='navigation__logo__image' />
              <span className='navigation__logo__text navigation__logo__text--desktop'>
                Global Innovation
                {' '}
                <br />
                & Design Standards
              </span>
              <span className='navigation__logo__text navigation__logo__text--mobile'>
                Shell GIDS
              </span>
            </Link>
            {!!user && (
              <Navigation
                handleSearchActive={toggleSearchActive}
              />
            )}
          </div>
        </div>
        <NavigationSearch
          active={searchActive}
          inputRef={searchInputRef}
          onSearchClick={() => setSearchActive(false)}
        />
      </nav>
    </header>
  );
}
